import React, { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { ModalFooter, ModalFormSection } from 'components/common/modals';
import { ButtonV2 } from 'components/common/ui';
import { FieldV2 } from 'components/common/form-controls';
import { LANGUAGES } from '@constants';

import validationSchema from './validationSchema';

const BookingSendSmsForm = ({
  templates,
  defaultValues,
  isLoading,
  onCancel,
  onSubmit,
}) => {
  const resolver = yupResolver(validationSchema);
  const methods = useForm({ defaultValues, resolver });

  useEffect(() => {
    if (defaultValues) {
      methods.reset(defaultValues);
    }
  }, [defaultValues, methods]);

  const template = methods.watch('template');
  const lang = methods.watch('lang');

  useEffect(() => {
    if (lang && templates?.length && template) {
      const selectedTemplate = templates?.find(
        (item) => item.name === template
      );
      methods.setValue('message', selectedTemplate?.content?.[lang]);
    }
  }, [lang, template, templates]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <FormProvider {...methods}>
      <form
        id="booking-send-sms-form"
        onSubmit={methods.handleSubmit(onSubmit)}
      >
        <ModalFormSection>
          <FieldV2
            isRequired
            disabled={isLoading || methods.formState.isSubmitting}
            label="Template"
            type="dropdown"
            options={templates}
            control={methods.control}
            name="template"
          />

          {template && (
            <FieldV2
              isRequired
              disabled={isLoading || methods.formState.isSubmitting}
              label="Language"
              type="dropdown"
              options={LANGUAGES}
              control={methods.control}
              name="lang"
            />
          )}

          {lang && template && (
            <FieldV2
              isRequired
              disabled
              label="Content"
              type="text"
              multiline
              rows={3}
              control={methods.control}
              name="message"
            />
          )}
        </ModalFormSection>
        <ModalFooter>
          <ButtonV2 type="button" variant="outlined" onClick={onCancel}>
            Cancel
          </ButtonV2>
          <ButtonV2
            form="booking-send-sms-form"
            type="submit"
            disabled={
              isLoading ||
              methods.formState.isSubmitting ||
              !methods.formState.isDirty
            }
          >
            Send
          </ButtonV2>
        </ModalFooter>
      </form>
    </FormProvider>
  );
};

export default BookingSendSmsForm;
